<template>
    <div class="marginCenter">
        <PreviewEditor :value="html"></PreviewEditor>
        <div class="marginBom54 overflow">
            <div
                class="flex-column marginBom18 pointer"
                v-for="(item, index) in contnetObj.contentAtt"
                :key="index"
                @click="downLoadFile(item.url, item.name)"
            >
                <!-- <img src="@/assets/images/wenjian.png" alt="" class="marginBom18"> -->
                <a class="fcolor_skyBlue">{{ item.name }}</a>
            </div>
        </div>
    </div>
</template>
<script>
import PreviewEditor from '@/components/previewEditor';
import { systemConfigTrainInstructionContentId, trainContent } from '@/utils/api';
import { downLoadFile } from '@/utils/myUtil';
export default {
    components: { PreviewEditor },
    data() {
        return {
            html: '',
            id: '',
            contnetObj: {
                contentAtt: []
            }
        };
    },
    created() {
        if (this.$route.query.id) {
            this.id = this.$route.query.id;
            this.getData();
        } else {
            systemConfigTrainInstructionContentId().then((res) => {
                if (res.code == 200) {
                    this.id = res.msg;
                    this.getData();
                }
            });
        }
    },
    methods: {
        downLoadFile(url, src) {
            downLoadFile(url, src);
        },
        getData() {
            trainContent(this.id).then((res) => {
                if (res.code == 200) {
                    this.html = res.data.content;
                    if (res.data.contentAtt) {
                        res.data.contentAtt = JSON.parse(res.data.contentAtt);
                    }
                    this.contnetObj = res.data;
                }
            });
        }
    }
};
</script>
<style lang="scss" scoped>
.btn {
    position: fixed;
    width: 200px;
    bottom: 50px;
    left: 50%;
    transform: translateX(-50%);
}

::v-deep img {
    max-width: 1200px;
}
</style>
